import { BaseBus } from "./BaseBus";

type Guid = any;

export class v_WarehousePartsBus extends BaseBus
{
    constructor(busObj: v_WarehousePartsBus = null) {
            super(busObj);

        }
    inventoryId: Guid;
    inventoryLocationId: Guid;
    inventoryLocationXREFId: Guid;
    isActive: boolean;
    partNumber: string;
    partDescription: string;
    fullDescription: string;
    minThreshold:number;
    maxThreshold:number;
    stockQuantity: number;
}
